// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__y6FZj","item":"Footer_item__hg+x9"};